'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/bee-overlay/build/trigger/index.js
// module id = 573
// module chunks = 0